import * as z from "zod/mini";

export const EventDocumentSchema = z.object({
  defaultImg: z.optional(z.string()),
  storagePath: z.optional(
    z.object({
      eventBanner: z.optional(z.string()),
    })
  ),
});
